import { safeParseAdminEnv } from './envSchema';

const _env = safeParseAdminEnv(process.env);

if (!_env.success) {
  const formatted = JSON.stringify(_env.error.format(), null, 2);
  console.error('❌ Invalid environment variables:\n', formatted);
  throw new Error('Invalid environment variables:\n' + formatted);
}

export const env = _env.data;
